// Arabic strings for the people & organisations stream — DEVELOPMENT DRAFT by Claude (PD-011);
// unreviewed until decision H-10 names a reviewer.
import type { enOrgs } from './en-orgs.ts';
import type { Message } from './types.ts';

export const arOrgs: { readonly [K in keyof typeof enOrgs]: Message } = {
  // ------------------------------------------------------------ validation and API messages
  'orgs.v.reason': 'اذكر سبباً لا يقل عن 3 أحرف.',
  'orgs.v.reasonRequired': 'اذكر سبب تغيير الاسم؛ يُحفظ في سجل الأسماء.',
  'orgs.v.item': 'اختر عنصراً معروفاً.',
  'orgs.v.notCollectedHere': 'لا تُجمع هذه المعلومات هنا. تُلتقط وثائق الهوية والصور فقط من خلال التحقق من الهوية.',
  'orgs.v.disallowed': 'لا تُجمع لهذا النوع من الزوار ولهذا الغرض (تقليل البيانات).',
  'orgs.v.nameTaken': 'توجد جهة نشطة تستخدم هذا الاسم.',
  'orgs.v.sponsorInactive': 'اختر مضيفاً نشطاً كراعٍ.',
  'orgs.v.organisationUnknown': 'اختر جهة من السجل.',
  'orgs.v.organisationInactive': 'هذه الجهة معطّلة.',
  'orgs.v.sameHost': 'اختر مضيفاً مختلفاً عن المضيف الحالي.',
  'orgs.v.matrix.duplicate': 'هذه القاعدة مكررة لنفس نوع الزائر والغرض.',
  'orgs.v.matrix.unknown_item': 'عنصر غير معروف: ليس عنصراً مدمجاً ولا حقلاً نشطاً في القاموس ولا مستنداً للتسجيل المسبق.',
  'orgs.v.matrix.unknown_category': 'نوع زائر غير معروف.',
  'orgs.v.matrix.purpose': 'استخدم رمز غرض (أحرف لاتينية صغيرة وأرقام و- و_).',
  'orgs.v.matrix.capture_only': 'تُلتقط الصور ووثائق الهوية فقط من خلال التحقق من الهوية؛ لا يمكن جعلها إلزامية هنا.',
  'orgs.v.matrix.document_mode': 'يمكن هنا منع مستندات التسجيل المسبق فقط؛ أما إلزاميتها فتبقى في سياسة الزوار.',
  'orgs.v.matrix.too_many': 'عدد القواعد كبير جداً.',
  'orgs.api.contractorGoverned': 'هذه الجهة شركة مقاولات: يُدار اسمها ونوعها وحالتها وراعيها في المقاولون والتصاريح.',
  'orgs.api.contractorAffiliation': 'يُربط عمّال المقاولين في المقاولون والتصاريح مع أدلتهم.',
  'orgs.api.nameTakenOnReactivate': 'توجد الآن جهة نشطة أخرى بهذا الاسم. غيّر اسم إحداهما أولاً.',
  'orgs.api.affiliationOverlap': 'لدى هذا الشخص انتماء لهذه الجهة في هذه التواريخ.',
  'orgs.api.affiliationEnded': 'هذا الانتماء ينتهي في هذا التاريخ أو قبله.',
  'orgs.api.linkSamePerson': 'اختر ملفين مختلفين.',
  'orgs.api.linkAlreadyDecided': 'يوجد قرار مسجّل لهذين الملفين. اعكسه أولاً.',
  'orgs.api.linkPrimaryIsLinked': 'هذا الملف مرتبط بملف رئيسي آخر. سجّل الربط على ذلك الملف الرئيسي.',
  'orgs.api.linkDuplicateHasLinks': 'الملف الآخر هو الملف الرئيسي لملفات مرتبطة. اعكس تلك الروابط أولاً.',
  'orgs.api.linkReversed': 'تم عكس هذا القرار مسبقاً.',
  'orgs.api.reassignmentResolved': 'لم تعد هذه الزيارة بحاجة إلى إعادة تعيين.',
  'orgs.api.rosterOpen': 'هذا الملف مُجهّز مسبقاً لهذه الزيارة. طبّق ذلك الاستيراد أو تجاهله أولاً.',
  'orgs.api.rosterNotEditable': 'تم تطبيق استيراد القائمة هذا أو تجاهله.',
  'orgs.api.rosterHasProblems': 'يتطلب خيار "الكل أو لا شيء" أن تكون كل الصفوف صالحة وكل التكرارات المحتملة محسومة.',
  'orgs.api.rosterRowFailed': 'تعذّرت إضافة صف، لذلك لم يُضف أي شيء (الكل أو لا شيء).',
  // ------------------------------------------------------------ collection items
  'orgs.item.email': 'البريد الإلكتروني',
  'orgs.item.phone': 'رقم الجوال',
  'orgs.item.organisation': 'الجهة',
  'orgs.item.photo': 'الصورة الشخصية',
  'orgs.item.id_document': 'صورة وثيقة الهوية',
  'orgs.item.id_number': 'رقم وثيقة الهوية',
  // ------------------------------------------------------------ navigation and roles
  'nav.people': 'الأشخاص والجهات',
  'specialist.profile-steward': 'أمين الملفات الشخصية',
  'pv.tab.collection': 'مصفوفة الجمع',
  'orgs.tab.organisations': 'الجهات',
  'orgs.tab.reassignments': 'إعادة تعيين المضيفين',
  // ------------------------------------------------------------ organisation register (PB-03-03)
  'orgs.title': 'الجهات',
  'orgs.intro': 'جهات العمل وشركات المقاولات والموردون وجهات التوصيل. تُعاد تسمية السجلات مع حفظ التاريخ أو تُعطّل، ولا تُحذف أبداً.',
  'orgs.register': 'سجل الجهات',
  'orgs.registerSub': 'منفصل عن الصلاحيات الفردية: الجهة أو الانتماء لا يمنح أي دخول.',
  'orgs.search': 'البحث في الجهات',
  'orgs.anyKind': 'أي نوع',
  'orgs.allStatuses': 'كل الحالات',
  'orgs.none': 'لا توجد جهات مطابقة.',
  'orgs.add': 'إضافة جهة',
  'orgs.col.organisation': 'الجهة',
  'orgs.col.kind': 'النوع',
  'orgs.col.status': 'الحالة',
  'orgs.kind.visitor': 'جهة زائرة',
  'orgs.kind.contractor': 'مقاول',
  'orgs.kind.vendor': 'مورّد',
  'orgs.kind.delivery': 'جهة توصيل',
  'orgs.kind.government': 'جهة حكومية',
  'orgs.kind.other': 'أخرى',
  'orgs.governed': 'تُدار في المقاولون والتصاريح',
  'orgs.governedNote': 'هذه الجهة شركة مقاولات. يُدار اسمها ونوعها وحالتها وراعيها وعمّالها في',
  'orgs.contractorHint': 'تُضاف شركات المقاولات في المقاولون والتصاريح مع أدلتها.',
  'orgs.displayName': 'الاسم المعروض',
  'orgs.legalName': 'الاسم القانوني',
  'orgs.facts': 'بيانات الجهة',
  'orgs.sponsor': 'الراعي',
  'orgs.created': 'تاريخ الإنشاء',
  'orgs.edit': 'تعديل',
  'orgs.renameHint': 'مطلوب عند تغيير الاسم؛ يُحفظ في سجل الأسماء.',
  'orgs.deactivate': 'تعطيل',
  'orgs.reactivate': 'إعادة التفعيل',
  'orgs.deactivateHint': 'تبقى الجهة في السجل مع تاريخها ونسبة الزيارات إليها؛ لكنها لا تُعرض للزيارات الجديدة.',
  'orgs.reactivateHint': 'يمكن اختيار الجهة مجدداً.',
  'orgs.contacts': 'جهات الاتصال',
  'orgs.noContacts': 'لا توجد جهات اتصال مسجّلة.',
  'orgs.addContact': 'إضافة جهة اتصال',
  'orgs.editContact': 'تعديل جهة الاتصال',
  'orgs.contactName': 'الاسم',
  'orgs.primary': 'جهة الاتصال الرئيسية',
  'orgs.nameHistory': 'سجل الأسماء',
  'orgs.noRenames': 'لم تُغيّر تسميتها قط.',
  'orgs.byOtherModule': 'سجل المقاولين',
  'orgs.attribution': 'الزيارات المنسوبة إلى هذه الجهة',
  'orgs.attributionSub': 'تحتفظ كل زيارة باسم الجهة الذي سُجّلت به، حتى بعد إعادة التسمية.',
  'orgs.attributedAs': 'مسجّلة باسم',
  'orgs.noVisits': 'لا توجد زيارات منسوبة إلى هذه الجهة ضمن نطاقك.',
  'orgs.people': { zero: 'لا أشخاص', one: 'شخص واحد', two: 'شخصان', few: '{count} أشخاص', many: '{count} شخصاً', other: '{count} شخص' },
  'orgs.partial': 'بعض السجلات خارج نطاقك ولا تظهر هنا.',
  // ------------------------------------------------------------ affiliations
  'orgs.aff.title': 'الانتماءات',
  'orgs.aff.sub': 'عمل أو ارتباط مؤرَّخ بجهات. الانتماءات لا تمنح أي دخول.',
  'orgs.aff.orgSub': 'الأشخاص المنتمون إلى هذه الجهة ممن يمكنك رؤيتهم.',
  'orgs.aff.none': 'لا توجد انتماءات مسجّلة.',
  'orgs.aff.add': 'إضافة انتماء',
  'orgs.aff.end': 'إنهاء الانتماء',
  'orgs.aff.role': 'الدور',
  'orgs.aff.period': 'الفترة',
  'orgs.aff.source': 'المصدر',
  'orgs.aff.source.register': 'سجل الجهات',
  'orgs.aff.source.contractor_register': 'سجل المقاولين (للقراءة فقط)',
  'orgs.aff.startsOn': 'يبدأ في',
  'orgs.aff.endsOn': 'ينتهي في',
  'orgs.aff.endsOnHint': 'اتركه فارغاً ما دام مستمراً.',
  'orgs.aff.open': 'مفتوح',
  'orgs.aff.current': 'حالي',
  'orgs.aff.past': 'غير حالي',
  'orgs.aff.contractorHint': 'يُربط عمّال المقاولين في المقاولون والتصاريح.',
  // ------------------------------------------------------------ link review (PB-03-04)
  'orgs.links.title': 'تطابقات محتملة',
  'orgs.links.sub': 'ملفات يمكنك رؤيتها تشترك في معرّفات مع هذا الملف. الاقتراحات لا تدمج الهويات تلقائياً أبداً.',
  'orgs.links.notProof': 'بيانات الاتصال المشتركة ليست دليلاً على الهوية. راجِع الأدلة المصدرية قبل الربط.',
  'orgs.links.none': 'لا توجد تطابقات محتملة بين الملفات التي يمكنك رؤيتها.',
  'orgs.links.col.profile': 'الملف',
  'orgs.links.col.reasons': 'أسباب التطابق',
  'orgs.links.reason.email': 'البريد نفسه',
  'orgs.links.reason.phone': 'الهاتف نفسه',
  'orgs.links.reason.name': 'الاسم نفسه',
  'orgs.links.reason.on_this_visit': 'موجود في هذه الزيارة',
  'orgs.links.reason.employee_number': 'الرقم الوظيفي نفسه',
  'orgs.links.linkedProfiles': { zero: 'لا ملفات مرتبطة', one: 'ملف مرتبط واحد', two: 'ملفان مرتبطان', few: '{count} ملفات مرتبطة', many: '{count} ملفاً مرتبطاً', other: '{count} ملف مرتبط' },
  'orgs.links.review': 'تسجيل مراجعة التطابق',
  'orgs.links.stewardOnly': 'يقرّر ذلك أمين الملفات الشخصية.',
  'orgs.links.reviewTitle': 'تسجيل مراجعة التطابق',
  'orgs.links.reasonsFound': 'أسباب التطابق: {reasons}',
  'orgs.links.decisionLabel': 'القرار',
  'orgs.links.keepSeparate': 'إبقاؤهما منفصلين',
  'orgs.links.link': 'ربطهما كشخص واحد',
  'orgs.links.linkHint': 'يصبح هذا الملف هو الملف الرئيسي. يبقى الملف الآخر وزياراته وأسماء جهاتها كما هي؛ ويمكن عكس الربط.',
  'orgs.links.keepHint': 'لن يُقترح الملفان كتطابق بعد الآن.',
  'orgs.links.reasonHint': 'اذكر الأدلة التي راجعتها.',
  'orgs.links.record': 'تسجيل القرار',
  'orgs.links.decisions': 'القرارات المسجّلة',
  'orgs.links.decision.linked': 'مرتبط',
  'orgs.links.decision.kept_separate': 'منفصلان',
  'orgs.links.status.active': 'سارٍ',
  'orgs.links.status.reversed': 'معكوس',
  'orgs.links.primaryOf': '{other} مرتبط بـ {primary}',
  'orgs.links.by': 'بواسطة {who}، {when}',
  'orgs.links.reversedBy': 'عُكس بواسطة {who}، {when}',
  'orgs.links.reverse': 'عكس',
  'orgs.links.reverseTitle': 'عكس القرار',
  'orgs.links.reverseHint': 'يبقى القرار في السجل؛ ولا يتغيّر شيء في أيّ من الملفين.',
  // ------------------------------------------------------------ host reassignment (PB-03-02)
  'orgs.ra.pageTitle': 'إعادة تعيين المضيفين',
  'orgs.ra.pageIntro': 'زيارات مستقبلية لم يعد مضيفها الرئيسي نشطاً. عيّن لكل زيارة مضيفاً نشطاً.',
  'orgs.ra.reassign': 'إعادة التعيين',
  'orgs.ra.title': 'إعادة تعيين المضيف الرئيسي',
  'orgs.ra.hint': 'اختر مضيفاً نشطاً. تغيير المضيف الرئيسي تغيير جوهري: تُطلب الموافقات مجدداً ويتلقى الزوار روابط دعوة جديدة.',
  'orgs.ra.search': 'البحث عن مضيفين',
  'orgs.ra.newHost': 'المضيف الرئيسي الجديد',
  'orgs.ra.impactTitle': 'ستُطلب الموافقات مجدداً.',
  'orgs.ra.impact': { zero: 'لن تتأثر أي موافقة.', one: 'ستُلغى موافقة واحدة لهذه الزيارة وتُطلب مجدداً.', two: 'ستُلغى موافقتان لهذه الزيارة وتُطلبان مجدداً.', few: 'ستُلغى {count} موافقات لهذه الزيارة وتُطلب مجدداً.', many: 'ستُلغى {count} موافقة لهذه الزيارة وتُطلب مجدداً.', other: 'ستُلغى {count} موافقة لهذه الزيارة وتُطلب مجدداً.' },
  'orgs.ra.confirm': 'راجعتُ الأثر',
  // ------------------------------------------------------------ roster import (PB-04-03)
  'orgs.roster.open': 'استيراد قائمة',
  'orgs.roster.title': 'استيراد قائمة مجموعة',
  'orgs.roster.intro': 'يصبح كل صف مشاركة مستقلة بموافقاتها وحالتها. التكرارات المحتملة تحتاج إلى قرارك؛ ولا يُدمج شيء.',
  'orgs.roster.file': 'ملف القائمة',
  'orgs.roster.fileHint': 'CSV (UTF-8) أو XLSX. لا تُستورد الصور أو وثائق الهوية أو كلمات المرور أبداً.',
  'orgs.roster.inspect': 'قراءة الأعمدة',
  'orgs.roster.mapping': { zero: 'طابِق الأعمدة (لا صفوف)', one: 'طابِق الأعمدة (صف واحد)', two: 'طابِق الأعمدة (صفّان)', few: 'طابِق الأعمدة ({count} صفوف)', many: 'طابِق الأعمدة ({count} صفاً)', other: 'طابِق الأعمدة ({count} صف)' },
  'orgs.roster.blocked': 'لا يمكن استيراد هذه الأعمدة أبداً: {columns}',
  'orgs.roster.ignore': 'لا تستورد',
  'orgs.roster.required': 'مطلوب',
  'orgs.roster.dryRun': 'فحص الصفوف',
  'orgs.roster.counts': '{rows} صفوف: {valid} صالحة، {invalid} بها مشكلات، {duplicate} تكرارات محتملة ({undecided} دون قرار).',
  'orgs.roster.applied': 'طُبّق: أُضيف {added}، تعذّر {failed}، تُخطّي {skipped}.',
  'orgs.roster.report': 'تقرير الصفوف',
  'orgs.roster.row': 'الصف',
  'orgs.roster.status': 'النتيجة',
  'orgs.roster.detail': 'التفاصيل',
  'orgs.roster.addedPerson': 'أُضيف إلى الزيارة',
  'orgs.roster.st.valid': 'جاهز',
  'orgs.roster.st.invalid': 'به مشكلات',
  'orgs.roster.st.duplicate': 'تكرار محتمل',
  'orgs.roster.st.added': 'أُضيف',
  'orgs.roster.st.failed': 'لم يُضف',
  'orgs.roster.st.skipped': 'تُخطّي',
  'orgs.roster.useExisting': 'استخدام هذا الملف',
  'orgs.roster.createSeparate': 'إنشاء ملف منفصل',
  'orgs.roster.skip': 'تخطٍّ',
  'orgs.roster.policy': 'طريقة التطبيق',
  'orgs.roster.validOnly': 'أضِف الصفوف الجاهزة وأبلِغ عن الباقي',
  'orgs.roster.allOrNothing': 'الكل أو لا شيء: أضِف كل الصفوف أو لا شيء',
  'orgs.roster.apply': 'تطبيق القائمة',
  'orgs.roster.done': 'أُضيف {added}، لم يُضف {failed}، تُخطّي {skipped}.',
  // ------------------------------------------------------------ collection matrix (PB-16-03)
  'orgs.mode.required': 'مطلوب',
  'orgs.mode.optional': 'اختياري',
  'orgs.mode.disallowed': 'لا يُجمع',
  'orgs.cm.title': 'مصفوفة الجمع',
  'orgs.cm.intro': 'ما يجوز جمعه لكل نوع من الزوار. يرفض الخادم القيم الممنوعة في نماذج الزيارة والتسجيل المسبق والأكشاك.',
  'orgs.cm.published': 'الإصدار {n} منشور {when}',
  'orgs.cm.nonePublished': 'لا توجد مصفوفة منشورة: كل عنصر يتبع سياسة الزوار وقاموس الحقول.',
  'orgs.cm.draft': 'مسودة الإصدار {n} مفتوحة',
  'orgs.cm.category': 'نوع الزائر',
  'orgs.cm.allTypes': 'كل أنواع الزوار (وطلبات الأكشاك)',
  'orgs.cm.item': 'العنصر',
  'orgs.cm.effective': 'الساري',
  'orgs.cm.rule': 'القاعدة',
  'orgs.cm.class': 'فئة الاحتفاظ',
  'orgs.cm.kind.builtin': 'بيان زائر',
  'orgs.cm.kind.field': 'حقل من القاموس',
  'orgs.cm.kind.document': 'مستند تسجيل مسبق',
  'orgs.cm.captureOnly': 'عبر التحقق من الهوية فقط',
  'orgs.cm.source.matrix': 'من المصفوفة',
  'orgs.cm.source.default': 'من السياسة أو القاموس',
  'orgs.cm.followDefault': 'اتباع السياسة والقاموس',
  'orgs.cm.purposeRules': 'قواعد لغرض عمل محدد',
  'orgs.cm.howEnforced': 'تُطبّق القاعدة الأكثر تحديداً: نوع الزائر والغرض، ثم نوع الزائر، ثم كل الأنواع والغرض، ثم كل الأنواع. البيان الممنوع لا يكون شرطاً للتقديم أبداً.',
  'orgs.cm.saveDraft': 'حفظ المسودة',
  'orgs.cm.publish': 'نشر',
  'orgs.cm.discard': 'تجاهل المسودة',
  'orgs.cm.readOnly': 'يغيّر مسؤولو الخصوصية المصفوفة.',
  'orgs.cm.formNote': 'لا تُجمع بعض بيانات الاتصال لهذا النوع من الزوار (تقليل البيانات).',
};
